import Button from "@/components/Atoms/Button";
import tw, { css, styled, theme } from "twin.macro";

export const stylesWrapperCard = css`
  ${tw`shadow-elevation-0 flex flex-col w-full gap-s p-s relative mb-8
    medium:(gap-sm p-sm)
    large:(gap-m p-m)
  `}
`;

const customStylesButton = css`
  ${tw`flex items-center justify-center p-3 shadow-elevation-1 absolute z-40 transition-all ease-in-out duration-300 top-[calc(50%-theme('space.1'))]
    large:(duration-500 top-[calc(50%-theme('space.1'))])
  `}

  & > span > svg {
    ${tw`w-3 h-3`}
  }

  &.swiper-navigation-hidden {
    ${tw`opacity-0`}
  }

  &.swiper-navigation-hidden,
  &.swiper-navigation-disabled {
    ${tw`opacity-0`}
  }
`;

export const StyledButtonPrev = styled(Button)`
  ${customStylesButton}
  ${tw`-left-m`}
`;

export const StyledButtonNext = styled(Button)`
  ${customStylesButton}
  ${tw`-right-m`}
`;

export const StylesWrapperPagination = styled.div`
  ${tw`!(transform translate-x-[-100%] left-[100%]) relative`}

  --swiper-pagination-color: ${theme`colors.secondary.50`};
  --swiper-pagination-bullet-size: 12px;
  --swiper-pagination-bullet-width: 12px;
  --swiper-pagination-bullet-height: 12px;
  --swiper-pagination-bullet-inactive-color: ${theme`colors.secondary.70`};
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bottom: 0;
`;

export const StyledWrapperSwiperProductGallery = styled.div<{ $isSmall: boolean }>`
  ${tw`w-full`}

  & article.swiper-slide {
    ${tw`w-min`};
  }
`;

export const StyledTitleHead = styled.div`
  ${tw`text-neutral-10 text-[0.9375rem] font-semibold leading-[0.9375rem] flex-1
      medium:(text-[1.125rem])
    `}
`;

export const StyledWrapperHead = styled.div`
  ${tw`flex items-center justify-between gap-m`}
`;
